import ButtonIcon from "#common/buttons/ButtonIcon"
import MainDetailsBody from "#core/components/main-details/MainDetailsBody"
import STATUS from "#vacantes/constants/status"
import OpenInNewIcon from "@mui/icons-material/OpenInNew"
import { generatePath } from "react-router-dom"

export default function VacancyDetailsBody({ vacante }) {
	const { fecha_rh } = vacante
	const notView = [STATUS.COMPLETED, STATUS.REJECTED].includes(vacante.status_id)
	const fields = [
		{
			label: "Jefe Directo",
			value: vacante.jefe_directo_name,
			size: 4,
		},
		{
			label: "Reclutador",
			value: vacante.reclutador_name,
			hidden: !vacante.reclutador,
		},
		{
			label: (
				<>
					# Promoción
					<ButtonIcon
						title="Ir a promoción"
						onClick={() => {
							const path = generatePath("/promociones/" + vacante?.promotion)
							window.open(path, "_blank")
						}}
						icon={<OpenInNewIcon color={"primary"} />}
						size="small"
					/>
				</>
			),
			value: vacante?.promotion,
			hidden: !vacante?.promotion,
		},
		{
			label: "Fecha Solicitud",
			value: dateAndDays(vacante.created_at, vacante.days_elapsed, notView),
		},

		{
			label: "Fecha Recepción RH",
			value: dateAndDays(vacante.fecha_rh, vacante.days_elapsed_rh, notView),
			hidden: !fecha_rh,
		},
		{
			label: "Sin Movimientos",
			value: `${vacante?.last_modification} días`,
			size: 2,
			hidden: notView,
		},
	]

	return <MainDetailsBody ItemsWrapper={fields} noUsePaper />
}

const dateAndDays = (date, days, onlyDate) => {
	let text = `${date || "N/A"}`
	if (days && !onlyDate) text += ` (${days} días)`

	return text
}
